export class SessionStorageConstants {
	static USER_LOCALE = "UserLocale";
  static CRC_LOCAL_SUPPORT_MAIL="crcsupport@solinas.net"
  static CRC_DEV_SUPPORT_MAIL="CRCSupport@compsych.com"
  static CRC_PROD_SUPPORT_MAIL="CRCSupport@compsych.com"
  static CRC_STAGE_SUPPORT_MAIL="CRCSupport@compsych.com"
}
